import { BaseGameScene } from '@/features/laneChooser/game/scenes/BaseGameScene';

import type { LaneChooserEventBus } from '@/features/laneChooser/game/EventBus';
import type { LaneChooserGameTheme } from '@/features/laneChooser/game/types';

export const getLaneChooserThemeSceneKey = (themeKey: string) => `laneChooserTheme-${themeKey}`;

export class LaneChooserThemeScene extends BaseGameScene {
	protected readonly themeSceneConfig: LaneChooserGameTheme;

	constructor(eventBus: LaneChooserEventBus, themeConfig: LaneChooserGameTheme) {
		super(getLaneChooserThemeSceneKey(themeConfig.key), eventBus);
		this.themeSceneConfig = themeConfig;
	}
}
